import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { DescribeChannelMembershipResponseFilterSensitiveLog, } from "../models/models_0";
import { de_DescribeChannelMembershipCommand, se_DescribeChannelMembershipCommand } from "../protocols/Aws_restJson1";
export { $Command };
export class DescribeChannelMembershipCommand extends $Command
    .classBuilder()
    .ep({
    ...commonParams,
})
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("ChimeMessagingService", "DescribeChannelMembership", {})
    .n("ChimeSDKMessagingClient", "DescribeChannelMembershipCommand")
    .f(void 0, DescribeChannelMembershipResponseFilterSensitiveLog)
    .ser(se_DescribeChannelMembershipCommand)
    .de(de_DescribeChannelMembershipCommand)
    .build() {
}
